<h3 mat-dialog-title>Do you really want to save all tasks as Did Not Complete?</h3>
<div mat-dialog-content>
    <mat-form-field class="card-dialog">
      <textarea  matInput cdkTextareaAutosize placeholder="Comment" [(ngModel)]="comment"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="submitDidNotComplete()" cdkFocusInitial>Submit</button>
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
</div>